import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import themeColors from '../../assets/styles/themeColors';
import { pxToRem } from '../../assets/styles/helper';
import Paragraph from '../Paragraph/Paragraph';
import { formatMoneyNumeral } from '../../util/helpers/numeralHelpers';
import ProductImage from './ProductImage';

const ProductAndAmountWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-top: 1px solid ${themeColors.colorBorderPrimary};
`;

const QuantityStyle = styled.span`
  margin-left: ${pxToRem(4)};
`;

const ProductWrapper = styled.span`
  display: flex;
  align-items: center;
  width: 70%;
`;

const LegacyOrderDetailsProductRow = ({ orderItem }) => (
  <ProductAndAmountWrapper hasBottomBorder>
    <ProductWrapper>
      <ProductImage
        productCode={orderItem.ProductCode}
        width={24}
        height={24}
      />
      <Paragraph>
        {orderItem.ProductCaption}
        <QuantityStyle>({orderItem.Quantity})</QuantityStyle>
      </Paragraph>
    </ProductWrapper>
    <Paragraph>{formatMoneyNumeral(orderItem.LineTotalPrice)}</Paragraph>
  </ProductAndAmountWrapper>
);

LegacyOrderDetailsProductRow.propTypes = {
  orderItem: PropTypes.shape({
    ProductCaption: PropTypes.string,
    Quantity: PropTypes.number,
    LineTotalPrice: PropTypes.number,
    ProductCode: PropTypes.string,
  }),
};

export default LegacyOrderDetailsProductRow;
